import api from '../api'

const redirect = ({ commit }, args) => {
  commit('RESET');
  commit('FETCHING', true);

  return api.redirect(args)
    .then(response => {
      window.location.href = process.env.VUE_APP_EDUCACIONIT + `inscripcion-alumni?contacto_id=${args.user_id}&calendario_id=${args.calendar_id}&token=${response.data.token}`
    })
    .catch(error => {
      commit('FETCHING', false);
      return error;
    });
};

const reset = ({ commit }) =>{
  commit('RESET');
};

export default {
  redirect,
  reset
}
